<section [ngStyle]="outerCss" class="no-ripple">
  <div hlmAccordion type="multiple" [class]="'accordion-widget-' + dataIn.uniqueId">
    @for (accordionConfig of accordionConfigs; track accordionConfig; let index = $index) {
      <div
        hlmAccordionItem
        role="heading"
        aria-level="1"
        [isOpened]="openStates[index]"
        [class]="'accordion-item-' + dataIn.uniqueId + '-' + index"
        [attr.data-layout-parent-id]="dataIn.uniqueId"
        [attr.data-layout-index]="index"
      >
        <div
          hlmAccordionTrigger
          role="button"
          [class]="'accordion-trigger-' + dataIn.uniqueId"
          [ngStyle]="getItemHeaderStyle(index)"
        >
          <span class="accordion-label" [innerHTML]="renderedTitles?.[index] || '' | safeHtml"></span>
          <mat-icon *ngIf="collapsedIcon" [svgIcon]="collapsedIcon" class="accordion-icon"></mat-icon>
          <mat-icon *ngIf="!collapsedIcon" [svgIcon]="'chevron-down'" class="accordion-icon"></mat-icon>
        </div>
        <hlm-accordion-content [ngStyle]="contentNgStyle">
          <section>
            @for (component of injectorArray(index); track component) {
              <div [class]="getWidgetClasses(component.widget)">
                <ng-container
                  *ngComponentOutlet="component.component; injector: component.injector"
                ></ng-container>
              </div>
            }
          </section>
        </hlm-accordion-content>
      </div>
    }
  </div>
</section>
